import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ContextFilesConfig } from './context-files-service.service';

export function provideContextFilesService(config: ContextFilesConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'contextFilesConfig', useValue: config }
  ]);
}
